import React from "react";
import CircularProgress from "@mui/material/CircularProgress";

import { useStyles } from "./LoaderWithOverlay.styles";

const LoaderWithOverlay = () => {
  const { loaderContainer, loader } = useStyles();
  return (
    <div className={loaderContainer}>
      <CircularProgress size="80" className={loader} />
    </div>
  );
};

export default LoaderWithOverlay;
